<template>
  <div>
    <v-flex xs12>
      <h2 class="text-center mb-3">Leietagers nye adresse</h2>
    </v-flex>
    <v-flex xs12 class="mb-2">
      <TextInput v-model="stepValues.textFields" @update-fields="updateFields"></TextInput>
    </v-flex>
    <StepButtons @next-page="next" @previous-page="previous" :step="this" />
  </div>
</template>

<script>
import step from "../../mixins/step";
import zipcodeSearch from "../../mixins/zipcodeSearch";
export default {
  mixins: [step, zipcodeSearch],
  methods: {
    setCity(json) {
      if(json.adresser.length > 0) {
        this.stepValues.textFields.city.value = json.adresser[0]['poststed']
      }
      else {
        this.stepValues.textFields.city.value = ''
      }
    }
  },
  computed: {
    finished: function() {
      if (
        Boolean(this.stepValues.textFields.street.value) &&
        Boolean(this.stepValues.textFields.zip.value) &&
        Boolean(this.stepValues.textFields.city.value)
      ) {
        return true;
      } else {
        this.$emit("error", "Alle felter må ha en verdi");
        return false;
      }
    },
    zip: function() {
      return this.stepValues.textFields.zip.value
    }
  },
  watch: {
    zip: {
      async handler(val) {
        if(val.length == 4) {
          this.getCityFromZipCode(val, this.setCity)
        }
      }
    }
  }
  
};
</script>
